exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-5px-right[data-v-07fb57d9]{word-break:break-all;overflow:auto}.table-responsive img[data-v-07fb57d9]{width:60px}table>tr>td[data-v-07fb57d9]:nth-child(odd){font-weight:600}", ""]);

// exports
